import React from 'react';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/system/useMediaQuery';
import {useTheme} from '@mui/joy';
import DuplicateNodeWizard from './index';
import {DuplicateTemplate} from './types';

interface Props {
    open: boolean;
    onClose?: () => void;
    template: DuplicateTemplate;
    refetchFunction?: () => void;
}

const DuplicateNodeWizardModal = ({open, onClose, template, refetchFunction}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
            <DuplicateNodeWizard
                template={template}
                onClose={onClose}
                refetchFunction={refetchFunction}
            />
        </Dialog>
    );
};

export default DuplicateNodeWizardModal;
